import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiHtml5,
  DiCss3,
  DiAngularSimple,
  DiRedis,
} from "react-icons/di";
import {
  SiTypescript,
  SiSolidity,
  SiPostgresql,
  SiExpress,
  SiNestjs,
  SiTailwindcss,
  SiNextdotjs,
  SiSvelte,
  SiFlask,
  SiPhp,
  SiCsharp,
  SiMicrosoftsqlserver,
  SiEmberdotjs,
  SiFastapi,
  SiWeb3Dotjs,
  SiVuedotjs,
  SiSqlalchemy,
  SiPydantic,
  SiPassport,
  SiSwagger,
  SiTensorflow,
  SiJest,
  SiRedux,
} from "react-icons/si";
import { FaReact, FaRegCircle } from "react-icons/fa"; // Added FaReact for React Native fallback

function Techstack() {
  const skills = [
    // Programming Languages
    { icon: <CgCPlusPlus />, name: "C++" },
    { icon: <DiPython />, name: "Python" },
    { icon: <DiJavascript1 />, name: "JavaScript" },
    { icon: <SiTypescript />, name: "TypeScript" },
    { icon: <SiMicrosoftsqlserver />, name: "SQL" },
    { icon: <SiPhp />, name: "PHP" },
    { icon: <SiCsharp />, name: "C#" },
    { icon: <SiSolidity />, name: "Solidity" },

    // Technologies/Frameworks
    { icon: <DiNodejs />, name: "Node.js" },
    { icon: <DiReact />, name: "React.js" },
    { icon: <FaReact />, name: "React Native" }, // Added React Native
    { icon: <FaRegCircle />, name: "Expo" }, // Added Expo with fallback
    { icon: <SiRedux />, name: "Redux" }, // Added Redux

    { icon: <SiNextdotjs />, name: "Next.js" },
    { icon: <SiSvelte />, name: "Svelte.js" },
    { icon: <DiAngularSimple />, name: "Angular" },
    { icon: <SiVuedotjs />, name: "Vue.js" },
    { icon: <SiEmberdotjs />, name: "Ember.js" },
    { icon: <SiExpress />, name: "Express.js" },
    { icon: <SiNestjs />, name: "Nest.js" },
    { icon: <SiFlask />, name: "Flask" },
    { icon: <SiFastapi />, name: "FastAPI" },
    { icon: <DiMongodb />, name: "MongoDB" },
    { icon: <SiPostgresql />, name: "PostgreSQL" },
    { icon: <SiWeb3Dotjs />, name: "Web3.js" },
    { icon: <DiRedis />, name: "Redis" },
    { icon: <SiSqlalchemy />, name: "SQLAlchemy" },
    { icon: <SiPydantic />, name: "Pydantic" },
    { icon: <SiTailwindcss />, name: "Tailwind" },
    { icon: <DiCss3 />, name: "CSS" },
    { icon: <DiHtml5 />, name: "HTML" },

    // Other tools & libraries
    { icon: <FaRegCircle />, name: "Moment.js" },
    { icon: <FaRegCircle />, name: "JWT" },
    { icon: <FaRegCircle />, name: "Bcrypt" },
    { icon: <SiPassport />, name: "Passport.js" },
    { icon: <SiSwagger />, name: "Swagger" },
    { icon: <SiTensorflow />, name: "TensorFlow" },
    { icon: <SiJest />, name: "Jest" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {skills.map((skill, index) => (
        <Col xs={4} md={2} key={index} className="tech-icons">
          {skill.icon}
          {skill.name && (
            <div style={{ marginTop: "5px", fontSize: "0.4em" }}>
              {skill.name}
            </div>
          )}
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
